
export const SendSMS = ({
  primaryColor = 'var(--primary-bg-color)',
  secondColor = 'var(--primary-background-text-color',
}) => {

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
    >
      <g
        id="Group_43568"
        data-name="Group 43568"
        transform="translate(-1284 -163)"
      >
        <circle
          id="Ellipse_1238"
          data-name="Ellipse 1238"
          cx="24"
          cy="24"
          r="24"
          transform="translate(1284 163)"
          fill={primaryColor}
        />
        <path
          id="chat-box"
          d="M48.8,48H35.217A3.22,3.22,0,0,0,32,51.217v8.577a3.22,3.22,0,0,0,3.217,3.217h1.072V65.87a.715.715,0,0,0,1.173.549l4.087-3.408H48.8a3.22,3.22,0,0,0,3.217-3.217V51.217A3.22,3.22,0,0,0,48.8,48ZM37.718,56.935a1.43,1.43,0,1,1,1.43-1.43A1.43,1.43,0,0,1,37.718,56.935Zm4.289,0a1.43,1.43,0,1,1,1.43-1.43A1.43,1.43,0,0,1,42.007,56.935Zm4.289,0a1.43,1.43,0,1,1,1.43-1.43A1.43,1.43,0,0,1,46.3,56.935Z"
          transform="translate(1265.992 130)"
          fill={secondColor}
        />
      </g>
    </svg>
  );
};
